import { render } from "./A7Data.vue?vue&type=template&id=a88be56e"
import script from "./A7Data.vue?vue&type=script&lang=js"
export * from "./A7Data.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__